import React, { useEffect, useState } from 'react'
import { PageSection, Title } from '@patternfly/react-core'
import GenericInput from 'src/frontend/app/components/Form/Input'
import GenericBreadCrumb from 'src/frontend/app/components/GenericBreadCrumb'
import { GenericAsyncTableData } from 'src/backoffice/app/components/GenericAsyncTableData'
import { TRIENNI_OPTIONS } from './CreaProroga'
import { PATH_TO_BO_LISTA_ISCRITTI_ORDINE, PATH_TO_BO_LISTA_PROROGHE, PATH_TO_BO_RIEPILOGO_RIPARTIZIONI } from 'src/app/utils/RoutesConstants'
import { getDefaultAxiosConfig, getFormazioneResourceApi } from 'src/app/utils/ManagerRestGateway'
import { TokenStore } from 'src/keycloak/jwt/TokenStore'

const Spacer = () => <br />

const getTriennioLabel = (value: any) => TRIENNI_OPTIONS.find((t) => t.value === Number(value))?.label || value

const formatDate = (date?: string) => {
  if (!date) return '-'

  const [year, month, day] = date.split('-')
  return `${day}-${month}-${year}`
}

const RiepilogoRipartizioni = (props: any) => {
  const searchParams = new URLSearchParams(window.location.search)
  const [id, setId] = useState<number | undefined>(() => {
    const idParam = new URLSearchParams(window.location.search).get('id')
    return idParam ? Number(idParam) : undefined
  })
  const cfPassato = searchParams.get('cf') ?? undefined

  const breadcrumbOptions = [
    {
      label: 'Lista proroghe',
      link: cfPassato ? `${PATH_TO_BO_LISTA_PROROGHE}?cf=${cfPassato}` : PATH_TO_BO_LISTA_ISCRITTI_ORDINE,
    },
    {
      label: 'Riepilogo ripartizioni',
      link: PATH_TO_BO_RIEPILOGO_RIPARTIZIONI,
    },
  ]

  const [cf, setCf] = useState<string | undefined>(undefined)

  const [reload, setReload] = useState(0)

  const isIscritto = TokenStore.getInstance().isCurrentAccountIscrittoOrdine()
  const isOdaf = TokenStore.getInstance().isCurrentAccountODAF()

  const loadData = async () => {
    const result = isIscritto
      ? await getFormazioneResourceApi().msfoFormazioneRiepilogoProrogheForUserGet(id, getDefaultAxiosConfig())
      : await getFormazioneResourceApi().msfoFormazioneRiepilogoProrogheGet(cf, id, getDefaultAxiosConfig())

    return {
      items: result.data || [],
      total: result.data?.length || 0,
    }
  }

  const handleInput = (id_data_number, dato: string) => {
    setCf(dato)
    setId(undefined)
    window.history.replaceState({}, '', window.location.pathname)
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setReload((r) => r + 1)
    }, 400)

    return () => clearTimeout(timer)
  }, [cf])

  return (
    <PageSection>
      <div className="container register-container">
        {isOdaf && <GenericBreadCrumb paths={breadcrumbOptions} />}

        <Spacer />

        <Title headingLevel="h1" size="lg">
          Riepilogo ripartizioni
        </Title>

        <Spacer />

        {isOdaf && (
          <GenericInput id="cf" type="text" placeholder="CODICE FISCALE" label="Codice Fiscale*" value={cf} onChange={handleInput} onKeyDown={() => {}} />
        )}

        <div>
          <GenericAsyncTableData
            tableKey="riepilogo-ripartizioni"
            key={`${reload}`}
            emptyMessage="Nessuna ripartizione presente"
            getRows={loadData}
            hidePagination={true}
            columns={[
              ...(isIscritto
                ? []
                : [
                    {
                      label: 'CF',
                      field: 'cfIscritto',
                      isSortable: false,
                    },
                  ]),
              {
                label: 'Proroga (dal / al)',
                field: 'periodoProroga',
                isSortable: false,
              },
              {
                label: 'CFP spostati',
                field: 'cfpSpostati',
                isSortable: false,
              },
              {
                label: 'Spostamento dal - al',
                field: 'spostamentoDalAl',
                isSortable: false,
              },
              {
                label: 'Triennio destinazione compensazione',
                field: 'triennioDestinazione',
                isSortable: false,
                render: (row: any) => getTriennioLabel(row.triennioDestinazione),
              },
              {
                label: 'Evento',
                field: 'eventoTitolo',
                isSortable: false,
                render: (row: any) => (
                  <div>
                    <div>{row.eventoTitolo}</div>
                    <div style={{ fontSize: 12, opacity: 0.7 }}>
                      Data inizio: {formatDate(row.eventoDataInizio)} / Data fine: {formatDate(row.eventoDataFine)}
                    </div>
                  </div>
                ),
              },
              {
                label: 'Tipo evento',
                field: 'tipoEvento',
                isSortable: false,
              },
              {
                label: 'Tipo CFP',
                field: 'tipoCfp',
                isSortable: false,
              },
            ]}
          />
        </div>
      </div>
    </PageSection>
  )
}

export default RiepilogoRipartizioni
